var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127.917,
    height: 127.917,
    viewBox: "0 0 127.917 127.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellisse_14",
    x: 0,
    y: 0,
    width: 127.917,
    height: 127.917,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_vocal_off",
    transform: "translate(15.213 15.174)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.21, -15.17)",
    filter: "url(#Ellisse_14)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_14-2",
    "data-name": "Ellisse 14",
    cx: 48.959,
    cy: 48.959,
    r: 48.959,
    transform: "translate(15 15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2625",
    "data-name": "Raggruppa 2625",
    transform: "translate(27.82 21.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3333",
    "data-name": "Tracciato 3333",
    d: "M20.492,0A20.492,20.492,0,0,1,40.984,20.492c0,11.317-18.917,33.274-20.492,31.968C21.241,53.645,0,31.81,0,20.492A20.492,20.492,0,0,1,20.492,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#707282",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_11",
    "data-name": "Ellisse 11",
    cx: 6.059,
    cy: 6.059,
    r: 6.059,
    transform: "translate(14.976 12.773)",
    fill: "none",
    stroke: "#707282",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin_icon.336b7d16986be114274a5267d063f33d.svg";
export { ForwardRef as ReactComponent };